import { render } from "./ItemYoutube.vue?vue&type=template&id=c3e57ab2&scoped=true"
import script from "./ItemYoutube.vue?vue&type=script&lang=js"
export * from "./ItemYoutube.vue?vue&type=script&lang=js"

import "./ItemYoutube.vue?vue&type=style&index=0&id=c3e57ab2&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e57ab2"]])

export default __exports__